import { optimizeImageForUpload } from './image'
import { isJpegFile } from './uploadFiles'

export default async function upload (self, uploadPhotos, selectSchoolId, selectYearId, selectEventId, eventName) {
    const photos = Array.from(uploadPhotos).filter(isJpegFile)
    const skippedCount = uploadPhotos.length - photos.length
    const sleep = (time) => new Promise(resolve => setTimeout(resolve, time))
    const failedPhotoNames = []
    let uploadCount = 0
    const uploadApiUrl = process.env.UPLOAD_API_URL || process.env.API_URL

    if (skippedCount) {
        self.$root.$emit('notification', 'is-warning', `JPEG以外の${skippedCount}件をスキップしました`)
    }

    for (const photo of photos) {
        let uploadPhoto = photo
        try {
            uploadPhoto = await optimizeImageForUpload(photo)
        } catch (e) {
            // ブラウザで処理できないJPEGは、サーバー側で検証・補正する。
        }

        let uploaded = false
        for (let attempt = 0; attempt < 3; attempt++) {
            const formData = new FormData()
            // 旧アップロードAPIはmultipartの名前を使うため、固定名にしない。
            // 新APIにはUTF-8の通常フィールドでも元名を渡す。
            formData.append('photo', uploadPhoto, photo.name)
            formData.append('original_name', photo.name)
            formData.append('school_id', selectSchoolId)
            formData.append('year_id', selectYearId)
            formData.append('event_id', selectEventId)

            try {
                const response = await self.axios.post(`${uploadApiUrl}/photographer/photo`, formData, {
                    withCredentials: true,
                    timeout: 120000
                })
                if (!response.data || response.data.message !== 'OK') {
                    // HTMLのログイン画面など、HTTP 200だけでは保存成功としない。
                    break
                }
                uploaded = true
                break
            } catch (e) {
                const status = e.response && e.response.status
                // 入力エラーの再送は避け、通信エラー・一時的なサーバー障害のみ再試行する。
                if (status && status >= 400 && status < 500 && status !== 408 && status !== 429) break
                if (attempt < 2) await sleep(5000)
            }
        }

        if (uploaded) {
            uploadCount++
            self.$root.$emit('notification', 'is-primary', `${uploadCount}/${photos.length} 件アップロード完了`)
        } else {
            failedPhotoNames.push(photo.name)
        }
    }

    sessionStorage.setItem(`${selectSchoolId}-${selectYearId}-${selectEventId}`, JSON.stringify(failedPhotoNames))
    self.$root.$emit('notification', failedPhotoNames.length ? 'is-warning' : 'is-primary',
        `${uploadCount}/${photos.length} ${eventName} のアップロードが完了しました（エラー${failedPhotoNames.length}件・対象外${skippedCount}件）`)
    return failedPhotoNames.length
}



// WEBPACK FOOTER //
// ./src/helpers/upload.js